import { render, staticRenderFns } from "./PublicRegionTopBanner.vue?vue&type=template&id=03ed2dae&scoped=true"
import script from "./PublicRegionTopBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicRegionTopBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PublicRegionTopBanner.vue?vue&type=style&index=0&id=03ed2dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed2dae",
  null
  
)

export default component.exports